module.exports = __webpack_public_path__ + "static/media/pending_actions.0a746e70.svg";